/** ログイン */

export default {
  title: 'JDYun活動システム',
  welcome: 'JDYun活動システムへようこそ',
  username: 'ユーザー名',
  password: 'パスワード',
  loginBtn: 'ログイン',
  captcha: '認証コード',
  remember: 'ログイン状態を維持',
  loginForm: 'ログインフォーム',
  otherWay: 'その他のログイン方法:',
  noAccount: 'アカウントをお持ちでないですか？',
  forgetPassword: 'パスワードをお忘れですか？',
  register: '今すぐ登録',
  thirdparty: 'サードパーティログイン',
  label: {
    code: 'SMSログイン',
    pswd: 'パスワードログイン'
  },
  phone: '電話番号',
  code: '{type}認証',
  sms: 'SMS',
  img: '画像',
  getCode: '送信',
  login: 'ログイン',
  choose: '事業者を選択',
  agree: '未登録の電話番号は自動的に登録されます。チェックすることで同意したものとみなされます',
  agreement: '《事業者プラットフォーム利用規約》',
  second: '秒',
  wx: 'WeChatログイン',
  activity_platform: {
    title: 'イベント管理プラットフォーム',
    subtitle: 'シンプルから複雑まで、無限のバリエーションと設定でイベントニーズに対応',
    features: [
      '複数ラウンド、複数カテゴリーグループで大規模イベントを開催',
      '人気ランキングでイベントの露出を増加',
      '広告ロードで多様なプロモーションを実現',
      '多角的な評価で最適な参加者を選定',
      '画像・動画のアップロードでカラフルな現場を表現'
    ]
  },
  evaluation: {
    title: '評価・昇格',
    subtitle: '多角的な評価で最も公平で正式な選考スコアリングを実現',
    features: [
      '異なるグループに多角的な採点方式を設定、複合的な選考',
      '採点、審査の2つの評価方式から選択可能',
      '複数の審査員が同時に評価・採点し、公平な権威性を確保',
      '参加者の評価成績による選別、昇格・落選をワンクリックで操作',
      '優秀な参加者に賞状と順位を付与'
    ]
  },
  moments: {
    title: '素晴らしい瞬間',
    subtitle: '画像・動画でイベントの素晴らしい瞬間を記録',
    features: [
      '画像や動画をアップロードし、モバイルで素晴らしい瞬間の記念として公開',
      'タグやカテゴリーで画像・動画を分類し、効率的に管理',
      '画像・動画のダウンロードでユーザーがハイライトを永久保存可能'
    ]
  },
  popularity: {
    title: '人気ランキング',
    subtitle: 'ランキングリストでイベントの人気を完璧に表現',
    features: [
      'いいねランキング、1人1票でイベントの高まりを表現',
      'ギフトランキング、支持する人気参加者に貢献',
      '複数ステージのランキングで各段階の人気を表示',
      '複数グループのランキングで各グループの人気参加者を表示'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/langs/ja/login.js